const initialState = {
    arealoading: false,
    areaData : []
  };
  
  const areaStore = (state = initialState, action ) => {
      switch(action.type){
          case "AREALOADER": {
            return {...state, arealoading:action.response }
          }
          case "GET_AREADATA": {
            return { ...state, areaData: action.response, arealoading:false };
          }
          case "UPDATE_AREADATA":{
            return { ...state, areaData: action.response, arealoading:false};
          }
          case "AREAFAIL":{
            return { ...state, arealoading: action.response };
          }
          default:
            return { ...state };
    }
  }
  
  export default areaStore;